import { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'

import { useFormik } from 'formik'
import * as Yup from 'yup'

import LoginUI from '../../ui/views/Login'
import { useAuthContext } from '../../auth/AuthProvider'
import useEnhancedFormik from '../../hooks/useEnhancedFormik'
import { decryptAesCredentials } from '../../libs/crypto'
import { loginPropTypes } from '../../common/propTypes'
import { HOME } from '../../routes'
import { useSession } from '../../auth/AuthProvider/useSession'

const LoginSchema = Yup.object().shape({
  user: Yup.string().email().required(),
  password: Yup.string().min(6).required(),
})

const Login = ({ onClickRequestPasswordReset }) => {
  const { lowerPasswordLogin } = useSession({ logoutCallback: () => {} })
  const { login, errors, isLoggingIn } = useAuthContext()
  const history = useHistory()

  const [loginHash, setLoginHash] = useState(null)

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)

    const autologinParam = urlParams.get('h')
    setLoginHash(autologinParam)

    const newSearch = new URLSearchParams(urlParams)
    newSearch.delete('h')

    history.replace({
      search: newSearch.toString(),
    })
  }, [history])

  const formik = useFormik({
    validationSchema: LoginSchema,
    initialValues: {
      user: '',
      password: '',
    },
    onSubmit: async values => {
      await login(values.user, values.password).then(loginSuccess => {
        if (!loginSuccess) {
          return
        }

        history.replace(HOME.linkTo())
      })
    },
  })
  const enhancedFormik = useEnhancedFormik(loginPropTypes, formik, errors)

  const handleInputChange = event => {
    enhancedFormik.handleChange(event)

    if (enhancedFormik.formErrors.length > 0) {
      enhancedFormik.clearGlobalFormErrors()
    }
  }

  useEffect(() => {
    const doLogin = async loginData => {
      const { user, password } = loginData
      if (password.length < 6) {
        if (lowerPasswordLogin(user, password)) {
          enhancedFormik.setFormErrors([
            { key: 'login:error:form:user-not-found' },
          ])
        }
        await formik.setValues(() => loginData, true)
        enhancedFormik.handleSubmit()
        return
      }
      await formik.setValues(() => loginData, true)

      enhancedFormik.handleSubmit()
    }

    if (loginHash) {
      const loginData = decryptAesCredentials(loginHash)

      if (loginData) doLogin(loginData)
    }
  }, [loginHash])

  return (
    <LoginUI
      onClickRequestPasswordReset={onClickRequestPasswordReset}
      values={formik.values}
      touched={formik.touched}
      fieldErrors={enhancedFormik.fieldErrors}
      formErrors={enhancedFormik.formErrors}
      onChange={handleInputChange}
      onSubmit={enhancedFormik.handleSubmit}
      onBlur={formik.handleBlur}
      isLoggingIn={isLoggingIn}
    />
  )
}

Login.propTypes = {
  onClickRequestPasswordReset: LoginUI.propTypes.onClickRequestPasswordReset,
}

export default Login
